import { c as _c } from "react/compiler-runtime";
import React, { useRef, useState } from "react";
import elements from "./VideoEmbed.module.scss";
import type { SanityImageObject } from "@sanity/image-url";
import { ResponsiveImage } from "../../../shared/responsiveimage";
import YouTube from "react-youtube";
export const VideoEmbed: React.FC<{
  id: string;
  thumbnail: SanityImageObject;
}> = t0 => {
  const $ = _c(11);
  const {
    id,
    thumbnail
  } = t0;
  const [showThumbnail, setShowThumbnail] = useState(true);
  const [videoTarget, setVideoTarget] = useState(null);
  useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = event => {
      setVideoTarget(event.target);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const onVideoReady = t1;
  let t2;
  if ($[1] !== showThumbnail || $[2] !== thumbnail || $[3] !== videoTarget) {
    t2 = showThumbnail && thumbnail && <div className={elements.thumbnail} onClick={() => {
      if (videoTarget) {
        setShowThumbnail(false);
        videoTarget.playVideo();
      }
    }}><ResponsiveImage image={thumbnail} layout="fill" sizes="(min-width: 1920px) 1714px, 90vw" /></div>;
    $[1] = showThumbnail;
    $[2] = thumbnail;
    $[3] = videoTarget;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      playerVars: {
        color: "white"
      },
      width: "auto",
      height: "auto"
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== id) {
    t4 = <YouTube videoId={id} opts={t3} iframeClassName={elements.videoinnercontainer} onReady={onVideoReady} />;
    $[6] = id;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <div className={elements.videocontainer}>{t2}{t4}</div>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};